import { Component, OnInit } from '@angular/core';
import { ApiService } from '../api.service';
import { HttpClient } from '@angular/common/http';
import * as moment from 'moment';

@Component({
  selector: 'app-my-orders',
  templateUrl: './my-orders.component.html',
  styleUrls: ['./my-orders.component.scss']
})
export class MyOrdersComponent implements OnInit {

  orders:any;

  unregistered:any;

  docs:any = {};

  prepa:any = {};

  creditRequestsByInvoice:any = {};
  
  orderStep = 0;


  inter:any;

  steps = [
  {details:'La commande est envoyée à mon commercial référent'},
  {details:'Ma commande est validée'},
  {details:"Ma commande est préparée et en attente d'expédition"},
  {details:'Ma commande est expédiée'},
  ]

  displayCreditRequest = false;
  creditLoading = false;
  creditSubmitting = false;
  creditLines: any[] = [];
  creditLineOptions: any[] = [];
  selectedCreditLine: any;
  creditForm: any = {
    qty_requested: null,
    reason: '',
    photos: [],
  };
  creditMaxPhotos = 8;
  creditContext: any = {};
  creditFileLoading = false;
  creditFileError: any;

  constructor(public api:ApiService, private http: HttpClient) { }

  ngOnInit(): void {
    this.refreshUnregistered(false);
  }



  refresh(e){
    let min = moment(e.min).format("DD/MM/YYYY");
    let max = moment(e.max).format("DD/MM/YYYY");
    this.api.postWS("sql=select",{
      fields:"Id, DocumentNumber, DocumentDate, Reference,NumberPrefix, TotalDueAmount",
      database:'SaleDocument T0',
      where:"T0.CustomerId = '"+this.api.user.Id+"' AND T0.DocumentDate BETWEEN '"+min+"' AND '"+max+"' AND Reference != 'SAV' AND (DocumentState != '4' OR DocumentState IS NULL)",
      orderBy: "Reference DESC, SysCreatedDate DESC",
    }).then((res:any)=>{
      let orders = {};
      let bls = [];
      for(let o of res){
        orders[o.Reference] = o;
        this.docs[o.Reference] = this.docs[o.Reference] ? this.docs[o.Reference] : {};
        this.docs[o.Reference][o.NumberPrefix] = o;
        
        if(o.NumberPrefix == 'BL')
          bls.push(o.DocumentNumber);
      }

      this.orders = Object.values(orders);
      this.loadCreditRequests();

      if(bls.length > 0){
        this.api.post("pro=getPrepa",bls).then((res:any)=>{
          this.prepa =  res;
        });
      }
    });

    if(!this.inter){
      this.inter = setInterval(()=>{
        this.refreshUnregistered(e);
      },10000);
    }
    
  }

  refreshUnregistered(e){
    this.api.postWS("order=checkForQuotes",{CustomerId:this.api.user.Id},false).then((res:any)=>{
      this.unregistered = res;
      if(this.unregistered.length === 0){
        if(this.inter){
          clearInterval(this.inter);
          if(e)
            this.refresh(e);
        }
      }
    });
  }

  setStep(row){
    let last = Object.keys(this.docs[row.Reference]).shift();
    if(last == 'DE')
      this.orderStep = 1;
    if(last == 'CM')
      this.orderStep = 2;
    if(last == 'BL')
      this.orderStep = 3;
    if(last == 'FA')
      this.orderStep = 4;
  }

  loadCreditRequests(){
    if(!this.api.user || !this.api.user.Id || !this.api.user.token){
      this.creditRequestsByInvoice = {};
      return;
    }
    this.api.post('credit=myList', {
      CustomerId: this.api.user.Id,
      token: this.api.user.token,
    }).then((res:any)=>{
      const map:any = {};
      if(res && res.statut == 'success' && res.data){
        for(let req of res.data){
          const key = req.InvoiceDocumentNumber;
          if(!key){
            continue;
          }
          // la plus récente est déjà en premier (ORDER BY created_at DESC)
          if(!map[key]){
            map[key] = req;
          }
        }
      }
      this.creditRequestsByInvoice = map;
    });
  }

  getCreditRequest(row){
    const fa = this.docs[row.Reference] && this.docs[row.Reference]['FA'];
    if(!fa || !fa.DocumentNumber){
      return null;
    }
    return this.creditRequestsByInvoice[fa.DocumentNumber] || null;
  }

  canRequestCredit(row){
    return !!(this.docs[row.Reference] && this.docs[row.Reference]['FA'] && !this.getCreditRequest(row));
  }

  creditStatusLabel(status){
    if(status === 'accepted') return 'Acceptée';
    if(status === 'refused') return 'Refusée';
    return 'En attente';
  }

  creditStatusSeverity(status){
    if(status === 'accepted') return 'success';
    if(status === 'refused') return 'danger';
    return 'warning';
  }

  openCreditRequest(row){
    if(!this.canRequestCredit(row)){
      this.api.error('Une demande d\'avoir existe déjà pour cette facture.');
      return;
    }
    const fa = this.docs[row.Reference] && this.docs[row.Reference]['FA'];
    if(!fa || !fa.Id){
      this.api.error('Facture introuvable pour cette commande.');
      return;
    }

    this.creditContext = {
      OrderReference: row.Reference,
      InvoiceDocumentNumber: fa.DocumentNumber,
      InvoiceDocumentId: fa.Id,
    };
    this.creditForm = {
      qty_requested: null,
      reason: '',
      photos: [],
    };
    this.selectedCreditLine = null;
    this.creditLines = [];
    this.creditLineOptions = [];
    this.creditFileError = null;
    this.displayCreditRequest = true;
    this.creditLoading = true;

    this.api.postWS("sql=select",{
      fields:"*",
      database:'SaleDocumentLine',
      where:"DocumentId = '"+fa.Id+"'"
    }).then((res:any)=>{
      const lines = (res || []).filter((line:any) => line.ItemId);
      this.creditLines = lines;
      this.creditLineOptions = lines.map((line:any) => ({
        label: line.ItemId + ' - ' + (line.DescriptionClear || line.ItemName || ''),
        value: line,
      }));
      this.creditLoading = false;
      if(this.creditLineOptions.length === 0){
        this.api.error('Aucun produit trouvé sur cette facture.');
      }
    }).catch(()=>{
      this.creditLoading = false;
      this.api.error('Impossible de charger les lignes de la facture.');
    });
  }

  onCreditLineSelect(){
    if(!this.selectedCreditLine){
      this.creditForm.qty_requested = null;
      return;
    }
    this.creditForm.qty_requested = this.selectedCreditLine.Quantity;
  }

  onCreditPhotoSelect(event){
    this.creditFileLoading = true;
    this.creditFileError = null;
    if(!this.creditForm.photos){
      this.creditForm.photos = [];
    }
    if(this.creditForm.photos.length >= this.creditMaxPhotos){
      this.creditFileLoading = false;
      this.creditFileError = 'Maximum '+this.creditMaxPhotos+' photos';
      return;
    }

    const file: File =
      (event && event.currentFiles && event.currentFiles[0]) ||
      (event && event.files && event.files[0]) ||
      (event && event.target && event.target.files && event.target.files[0]);
    if(!file){
      this.creditFileLoading = false;
      return;
    }

    if(!file.type || file.type.indexOf('image/') !== 0){
      this.creditFileLoading = false;
      this.creditFileError = 'Le fichier doit être une image';
      return;
    }

    this.compressCreditPhoto(file).then((compressed)=>{
      const formData = new FormData();
      formData.append('file', compressed, compressed.name || 'avoir.jpg');
      this.http.post('https://blackrockgames.fr/upload/index.php?sav', formData).subscribe((res:any)=>{
        if(res && res['statut'] == 'ok' && res['src']){
          const fileName = String(res['src']).split('/').pop();
          const url = 'https://espacepro.blackrockgames.fr/upload/sav/' + fileName;
          this.creditForm.photos = [...this.creditForm.photos, url];
        }else{
          this.creditFileError = (res && res['message']) || 'Upload impossible';
        }
        this.creditFileLoading = false;
      }, ()=>{
        this.creditFileLoading = false;
        this.creditFileError = 'Une erreur a eu lieu';
      });
    }).catch(()=>{
      this.creditFileLoading = false;
      this.creditFileError = 'Impossible de compresser l\'image';
    });
  }

  removeCreditPhoto(index: number){
    if(!this.creditForm.photos){
      return;
    }
    this.creditForm.photos = this.creditForm.photos.filter((_, i) => i !== index);
  }

  /**
   * Redimensionne / compresse l'image côté client (max 1600px, JPEG ~0.7)
   * pour éviter de stocker de gros fichiers originaux.
   */
  private compressCreditPhoto(file: File, maxSize = 1600, quality = 0.7): Promise<File>{
    return new Promise((resolve, reject)=>{
      const reader = new FileReader();
      reader.onerror = () => reject(new Error('read'));
      reader.onload = () => {
        const img = new Image();
        img.onerror = () => reject(new Error('image'));
        img.onload = () => {
          let width = img.width;
          let height = img.height;
          if(width > maxSize || height > maxSize){
            if(width > height){
              height = Math.round(height * (maxSize / width));
              width = maxSize;
            }else{
              width = Math.round(width * (maxSize / height));
              height = maxSize;
            }
          }

          const canvas = document.createElement('canvas');
          canvas.width = width;
          canvas.height = height;
          const ctx = canvas.getContext('2d');
          if(!ctx){
            reject(new Error('canvas'));
            return;
          }
          ctx.drawImage(img, 0, 0, width, height);
          canvas.toBlob((blob)=>{
            if(!blob){
              reject(new Error('blob'));
              return;
            }
            const baseName = (file.name || 'avoir').replace(/\.[^.]+$/, '');
            resolve(new File([blob], baseName + '.jpg', { type: 'image/jpeg' }));
          }, 'image/jpeg', quality);
        };
        img.src = reader.result as string;
      };
      reader.readAsDataURL(file);
    });
  }

  canSubmitCredit(){
    const qty = parseFloat(this.creditForm.qty_requested);
    const max = this.selectedCreditLine ? parseFloat(this.selectedCreditLine.Quantity) : 0;
    return !!(
      this.selectedCreditLine &&
      this.creditForm.reason &&
      this.creditForm.reason.trim() &&
      !isNaN(qty) &&
      qty > 0 &&
      qty <= max &&
      !this.creditSubmitting &&
      !this.creditFileLoading
    );
  }

  submitCreditRequest(){
    if(!this.canSubmitCredit()){
      this.api.error('Merci de renseigner tous les champs obligatoires.');
      return;
    }

    const user = this.api.user;
    const line = this.selectedCreditLine;
    const data = {
      CustomerId: user.Id,
      token: user.token,
      InvoiceDocumentNumber: this.creditContext.InvoiceDocumentNumber,
      InvoiceDocumentId: this.creditContext.InvoiceDocumentId,
      OrderReference: this.creditContext.OrderReference,
      ItemId: line.ItemId,
      ItemName: line.DescriptionClear || line.ItemName || '',
      qty_initial: line.Quantity,
      qty_requested: this.creditForm.qty_requested,
      reason: this.creditForm.reason.trim(),
      photos: this.creditForm.photos || [],
    };

    this.creditSubmitting = true;
    this.api.post('credit=create', data).then((res:any)=>{
      if(res && res.statut == 'success'){
        this.api.success('Votre demande d\'avoir a bien été envoyée.');
        this.displayCreditRequest = false;
        this.loadCreditRequests();
      }else{
        this.api.error((res && res.message) || 'La demande n\'a pas pu être enregistrée.');
      }
      this.creditSubmitting = false;
    }).catch(()=>{
      this.creditSubmitting = false;
      this.api.error('La demande n\'a pas pu être enregistrée.');
    });
  }
}
